import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Building } from 'app/modules/models/building.type';
import { FeatureCollection, LongLatDto } from 'app/modules/models/stateAdress.type';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BuildingService {
  protected apiRoute = environment.RESOURCE_API;
  
  constructor(private _http: HttpClient) {}

  getCadastral(longLatDto: LongLatDto){
    const route = this.apiRoute + environment.apiCatalog.building.subRoutes.getCadastral;
    return this._http.post<any[]>(route, longLatDto, this.prepareHeader());
  }

  getAddress(address: string){
    const route = this.apiRoute + environment.apiCatalog.building.subRoutes.getAddress + address;
    return this._http.get<FeatureCollection>(route,this.prepareHeader());
  }

  updateBuilding(building : Building): Observable<Building> {
    const route = this.apiRoute + environment.apiCatalog.building.subRoutes.updateBuilding;
    return this._http.post<Building>(route, building, this.prepareHeader());
  }

  private prepareHeader(): Object {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
    return { headers: headers };
  }
}
